export default "__VITE_ASSET__DEqo2gVF__"